import purchase from '#frontend/dtm/event/purchase.js';

/**
 * Thank you page object
 * @param {object} cart Cart object
 * @returns {object} Created Cart Page object
 */
export default (cart) => ({
	page_name: 'confirmation',
	store_paymentmethod: cart.selectedPayment.type,
	...purchase(cart)
});
